
//          let uri = `/api/protected/cfop/pesquisar?id=${id}&natureza=${natureza}`

import axios from "axios";
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
    state: {
        lista: [],
        natureza: null,
        perPage: 100,
        registroSelecionadoId: null,
        paginaAtual: 1,
    },
    getters: {
      LISTA: state => {
          return state.lista
      },
      PER_PAGE: state => { 
          return state.perPage
      },
      NATUREZA: state => { 
          return state.natureza
      },
      REGISTRO_SELECIONADO_ID: state => {
          return state.registroSelecionadoId
      },
      PAGINA_ATUAL: state => {
          return state.paginaAtual
      }
    },
    /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
    mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_NATUREZA: (state, payload) => {
          state.natureza = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        lista = [],
        natureza = null,
        registroSelecionadoId = null
        paginaAtual = 1
      },
      SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
          state.filtroAvancado = false,
          state.lista = [],
          state.paginaAtual = 1
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters }, { skipConfirmation = false } = {}) => {
      return new Promise((resolve, reject) => {
        // Monte um objeto com todos os possíveis filtros
        const filtros = {
            id: getters.ID ?? null,
            natureza: getters.NATUREZA ?? null
        }

        axios.post(`/api/protected/cfop/pesquisar`, filtros)
        .then(({ data, status }) => {
            // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
            if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
              // Retorna os dados sem comitar, indicando que precisa de confirmação
              resolve({ 
                data, 
                status,
                needsConfirmation: true,
                count: data.length
              });
              return
            }
            
            // Carrega os dados normalmente
            commit("SET_LISTA", data);
            if (status === 200 || status === 201) {
                resolve({ data, status, needsConfirmation: false });
            }
        })
        .catch(error => {
          reject(error)
        })
      })
    }
  }
}          


// WEBPACK FOOTER //
// ./src/vuex/modulos/cfop-store.js